import React, { useEffect, useState } from "react";
import { Paper, Typography, Grid } from '@mui/material';

export default function ProductListContainer( {containedComponent}) {

  return (
    <Paper elevation={0}
    sx={{
      display: 'flex',
      m: .25,
      p: .25,
      backgroundColor:'secondary.lighter',
      // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
      // color: (theme) =>
      //   theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
      //border: '1px solid',
      // borderColor: (theme) =>
      //   theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
      // //borderRadius: 2,
      //fontSize: '0.875rem',
      //fontWeight: '700',
      width:'100%',
      alignContent:'center',
      justifyContent:'center',
      
    }}
  >
      <Grid container direction="column">
      {containedComponent}
      </Grid>
    </Paper>
  );
}
